{
  "Basic": [
    {
      "menu_label": "Global Consumer Search",
      "menu_id": "globalConsumerSearch",
      "display": "y",
      "landing_component": "globalConsumerSearch"
    },
    {
      "menu_label": "Consumer Referral",
      "menu_id": "consumerReferral",
      "display": "y",
      "landing_component": "referralList"
    },
    {
      "menu_label": "Consumer Registration",
      "menu_id": "consumerRegistration",
      "landing_component": "participantEnrollmentList",
      "display": "y"
    },
    {
      "menu_label": "Association Registration",
      "menu_id": "personalAssistantRegistration",
      "landing_component": "providerEnrollmentList",
      "display": "y"
    }
  ],
  "Timesheets": [
    {
      "menu_label": "Timesheets",
      "menu_id": "timesheets",
      "display": "y",
      "landing_component": "timesheet"
    },
    {
      "menu_label": "Pended Timesheets",
      "menu_id": "pendedTimesheets",
      "display": "y",
      "landing_component": "pendedTimesheets"
    },
    {
      "menu_label": "Authorizations",
      "menu_id": "authorizations",
      "display": "y",
      "landing_component": "authorizations"
    },
    {
      "menu_label": "Payroll Processing",
      "menu_id": "payrollProcessing",
      "display": "y",
      "landing_component": "payrollProcessing"
    },
    {
      "menu_label": "Payroll NAT Pay",
      "menu_id": "payrollNATPay",
      "display": "y",
      "landing_component": "payrollNATPay"
    },
    {
      "menu_label": "Auth Utilization Analysis",
      "menu_id": "authUtilizationAnalysis",
      "display": "y",
      "landing_component": "authUtilizationAnalysis"
    }
  ],
  "Others": [
    {
      "menu_label": "Case Managers / LDSS Office",
      "menu_id": "caseManagers",
      "display": "y",
      "landing_component": "caseManagerList"
    },
    {
      "menu_label": "Process Codes",
      "menu_id": "processCodes",
      "display": "y",
      "landing_component": "processCodeList"
    },
    {
      "menu_label": "Service Codes",
      "menu_id": "serviceCodes",
      "display": "y",
      "landing_component": "serviceCodeList"
    },
    {
      "menu_label": "File Triage",
      "menu_id": "fileTriage",
      "display": "y",
      "landing_component": "fileTriage"
    },
    {
      "menu_label": "File Upload Notification",
      "menu_id": "fileUploadNotification",
      "display": "y",
      "landing_component": "fileUploadNotification"
    },
    {
      "menu_label": "Config",
      "menu_id": "applicationConfig",
      "display": "y",
      "landing_component": "configList"
    }
  ],
  "Billing": [
    {
      "menu_label": "Consumer Ledger",
      "menu_id": "viewLedger",
      "display": "y",
      "landing_component": "consumerLedgerList"
    },
    {
      "menu_label": "Claim Ledger",
      "menu_id": "viewClaimLedger",
      "display": "y",
      "landing_component": "claimLedgerList"
    },
    {
      "menu_label": "Deposit Entry",
      "menu_id": "viewDepositEntry",
      "display": "y",
      "landing_component": "depositEntryList"
    },
    {
      "menu_label": "Net Ledger",
      "menu_id": "viewGlobalLedger",
      "display": "y",
      "landing_component": "globalLedgerList"
    },
    {
      "menu_label": "Claim Batches",
      "menu_id": "viewBatches",
      "display": "n",
      "landing_component": "claimBatchesList"
    },
    {
      "menu_label": "Claim Files",
      "menu_id": "viewFiles",
      "display": "n",
      "landing_component": "claimFilesList"
    },
    {
      "menu_label": "Claims",
      "menu_id": "viewClaims",
      "display": "n",
      "landing_component": "viewClaimsList"
    },
    {
      "menu_label": "PMPM Claims",
      "menu_id": "billingPMPMClaims",
      "display": "n",
      "landing_component": "billingPmpmClaimsList"
    },
    {
      "menu_label": "Ignored Timesheets",
      "menu_id": "viewIgnoredTimesheets",
      "display": "n",
      "landing_component": "viewIgnoredTimesheetsList"
    },
    {
      "menu_label": "Recon Files",
      "menu_id": "viewReconFiles",
      "display": "n",
      "landing_component": "billingReconFilesList"
    },
    {
      "menu_label": "Payments",
      "menu_id": "viewPayments",
      "display": "y",
      "landing_component": "billingPaymentReconList"
    },
    {
      "menu_label": "CDR Recon",
      "menu_id": "viewCdrRecon",
      "display": "n",
      "landing_component": "cdrReconList"
    },
    {
      "menu_label": "Workday",
      "menu_id": "viewWorkday",
      "display": "n",
      "landing_component": "workdayList"
    },
    {
      "menu_label": "Workday Status",
      "menu_id": "viewWorkdayStatus",
      "display": "n",
      "landing_component": "workdayStatusList"
    }
  ],
  "Adjustments": [
    {
      "menu_label": "Payroll Adjustment",
      "menu_id": "payrollAdjustment",
      "display": "y",
      "landing_component": "payrollAdjustment"
    },
    {
      "menu_label": "Payroll Approvals",
      "menu_id": "payrollApprovals",
      "display": "y",
      "landing_component": "payrollApprovals"
    },
    {
      "menu_label": "Billing Adjustment",
      "menu_id": "billingAdjustment",
      "display": "y",
      "landing_component": "billingAdjustment"
    },
    {
      "menu_label": "Billing Approvals",
      "menu_id": "billingApprovals",
      "display": "n",
      "landing_component": "billingApprovals"
    },
    {
      "menu_label": "Payroll Resurrect",
      "menu_id": "payrollResurrect",
      "display": "y",
      "landing_component": "payrollResurrect"
    },
    {
      "menu_label": "Billing Claim Adjustment",
      "menu_id": "billingClaimAdjustment",
      "display": "y",
      "landing_component": "billingClaimAdjustment"
    }
  ],
  "Billing Reports": [
    {
      "menu_label": "Summary Report",
      "menu_id": "summaryReport",
      "display": "n",
      "landing_component": "summaryBillingReport"
    },
    {
      "menu_label": "Activity Report",
      "menu_id": "activityReport",
      "display": "n",
      "landing_component": "activityBillingReport"
    },
    {
      "menu_label": "Denial Report",
      "menu_id": "denialReport",
      "display": "n",
      "landing_component": "denialBillingReport"
    },
    {
      "menu_label": "Ignored Timesheet Report",
      "menu_id": "ignoredTimesheetReport",
      "display": "n",
      "landing_component": "ignoredTimesheetReport"
    },
    {
      "menu_label": "Batch Report",
      "menu_id": "batchReport",
      "display": "n",
      "landing_component": "batchReport"
    },
    {
      "menu_label": "Resubmission Report",
      "menu_id": "resubmissionReport",
      "display": "n",
      "landing_component": "resubmissionReport"
    }
  ],
  "Rates": [
    {
      "menu_label": "Consumer - Personal Assistant Rates",
      "menu_id": "participantProviderRates",
      "display": "y",
      "landing_component": "participantProviderRatesList"
    },
    {
      "menu_label": "Payable - Personal Assistant Rates",
      "menu_id": "payableProviderRates",
      "display": "y",
      "landing_component": "payablePersonalAssistantRates"
    },
    {
      "menu_label": "Billable - Personal Assistant Rates",
      "menu_id": "billableProviderRates",
      "display": "y",
      "landing_component": "billablePersonalAssistantRates"
    }
  ]
}